var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaiting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14h-1v-.8c0-2.12-.99-3.85-2.58-4.52a.73.73 0 0 1 0-1.36c1.6-.67 2.58-2.4 2.58-4.52V2h1a.5.5 0 0 0 0-1h-11a.5.5 0 1 0 0 1h1v.8c0 2.12.99 3.85 2.58 4.52a.73.73 0 0 1 0 1.36c-1.6.67-2.58 2.4-2.58 4.52v.8h-1a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1Zm-9 0v-.8c0-1.71.75-3.1 1.97-3.6a1.73 1.73 0 0 0 0-3.2C5.25 5.9 4.5 4.51 4.5 2.8V2h7v.8c0 1.71-.75 3.1-1.97 3.6a1.73 1.73 0 0 0 0 3.2c1.22.5 1.97 1.89 1.97 3.6v.8h-7Zm6.5-1a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 13a3 3 0 0 1 6 0Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.2a683f5fb9599d7ae1535a7c30f3475b.svg";
export { ForwardRef as ReactComponent };